export default "__VITE_ASSET__CshPmcNo__"